import React from 'react';
import FaqsDesktop from './faqs/FaqsDesktop';
import FaqsMobile from './faqs/FaqsMobile';
import { FaqsSection } from './styles/Faqs.styled';
import FaqsBreadCrumb from './faqs/FaqsBreadCrumb';

export default function Faqs({ data, id, dir }) {
  return (
    <FaqsSection id={id}>
      <FaqsBreadCrumb data={data} dir={dir} />
      <FaqsDesktop data={data} dir={dir} />
      <FaqsMobile data={data} dir={dir} />
    </FaqsSection>
  );
}
